// client/src/i18n/translations/fr.js — Maxula
// Dictionnaire FRANÇAIS (langue de référence — toute clé absente en AR
// retombe automatiquement ici).
const fr = {
  // ---- Navigation ----
  'nav.home': 'Accueil',
  'nav.categories': 'Catégories',
  'nav.cities': 'Villes',
  'nav.newest': 'Nouveautés',
  'nav.bestOffers': 'Meilleures offres',
  'nav.merchants': 'Marchands',
  'nav.subscriptions': 'Abonnements',
  'nav.support': 'Support',
  'nav.searchPlaceholder': 'Rechercher des deals...',
  'nav.seeAllResults': 'Voir tous les résultats pour « {{q}} »',
  'nav.deals': 'Deals',
  'nav.login': 'Connexion',
  'nav.register': 'Inscription',
  'nav.logout': 'Déconnexion',
  'nav.myAccount': 'Mon compte',
  'nav.dashboard': 'Tableau de bord',

  // ---- Commun ----
  'common.seeAll': 'Voir tout',
  'common.seeMore': 'Voir plus',
  'common.loading': 'Chargement...',
  'common.apply': 'Appliquer',
  'common.reset': 'Réinitialiser les filtres',
  'common.previous': 'Précédent',
  'common.next': 'Suivant',
  'common.page': 'Page',
  'common.currency': 'MAD',
  'common.search': 'Rechercher',
  'common.prevShort': 'Préc',
  'common.nextShort': 'Suiv',
  'common.show': 'Afficher',
  'common.perPage': '/ page',

  // ---- Recherche (page /search) ----
  'search.resultsFor': 'Résultats pour « {{q}} »',
  'search.allDeals': 'Tous les deals',
  'search.results_one': '{{count}} résultat',
  'search.results_other': '{{count}} résultats',
  'search.filters': 'Filtres',
  'search.activeFilters_one': '{{count}} filtre actif',
  'search.activeFilters_other': '{{count}} filtres actifs',
  'search.sortBy': 'Trier par',
  'search.sort.newest': 'Plus récents',
  'search.sort.priceAsc': 'Prix croissant',
  'search.sort.priceDesc': 'Prix décroissant',
  'search.sort.discount': 'Réduction la plus forte',
  'search.sort.popular': 'Les plus populaires',
  'search.price': 'Prix (MAD)',
  'search.min': 'Min',
  'search.max': 'Max',
  'search.categories': 'Catégories',
  'search.cities': 'Villes',
  'search.noResults': 'Aucun résultat',
  'search.noResultsHint': "Essayez d'autres mots-clés ou élargissez vos filtres.",
  'search.viewAllDeals': 'Voir tous les deals',

  // ---- Accueil ----
  'home.heroTitle': 'Découvrez les meilleurs deals au Maroc',
  'home.heroSubtitle': 'Économisez jusqu\u2019à 90% sur les restaurants, spa, voyages et bien plus encore',
  'home.exploreDeals': 'Explorer les Deals',
  'home.howItWorks': 'Comment ça marche',
  'home.howItWorksSub': 'Découvrez comment profiter des meilleures offres en 3 étapes simples',
  'home.step1': '1. Trouvez votre deal',
  'home.step1Sub': 'Parcourez nos offres par catégories',
  'home.step2': '2. Achetez en ligne',
  'home.step2Sub': 'Payez en ligne et recevez votre bon',
  'home.step3': '3. Profitez de l\u2019offre',
  'home.step3Sub': 'Présentez votre voucher et profitez',
  // Tuiles d'accueil (4 bannières cliquables) — remplacent les 3 étapes
  'home.tilesSub': 'Choisissez votre univers et accédez directement aux offres',
  'home.tilesCta': 'Voir les offres',
  'home.tilesDeals': 'offres',
  // Bloc mobile (MobileDiscover) — remplace la bannière sur téléphone
  'home.mobileTitle': 'Les meilleures offres près de chez vous',
  'home.mobileSub': 'Choisissez un univers et réservez en quelques clics',
  'home.mobileAllCategories': 'Tout voir',
  'home.popularCategories': 'Catégories populaires',
  'home.popularCategoriesSub': 'Découvrez nos offres par catégorie',
  'home.featuredSub': 'Découvrez nos meilleures offres du moment',
  'home.allDealsSub': 'Découvrez toutes nos offres disponibles',
  'home.noCategory': 'Aucune catégorie',
  'home.noDeals': 'Aucune offre disponible',
  'home.noFeatured': 'Aucune offre en vedette',

  // ---- Pied de page ----
  'footer.company': 'Entreprise',
  'footer.poles': 'Nos pôles',
  'footer.contact': 'Contact',

  // ---- Suggestions ----
  'sugg.deals': 'Deals',
  'sugg.merchants': 'Marchands',
  'sugg.categories': 'Catégories',

  // ---- Bannière publicitaire (sponsorisée) ----
  'ad.sponsored': 'Sponsorisé',
  'ad.cta': "Voir l'offre",
  'ad.close': 'Fermer',

  // ---- (v1.177) Accueil : titres de sections ----
  'home.featured': 'Offres en vedette',
  'home.allDeals': 'Toutes les offres',
  'home.seeAllDeals': 'Voir tous les deals',
  'home.dealsByCity': 'Deals par ville',
  'home.dealsByCitySub': 'Trouve des promotions près de chez toi ou découvre de nouvelles villes.',
  'home.offers': 'offres',
  'home.categoriesCount': 'catégories',
  'home.citiesCount': 'villes',
  'home.noCities': 'Aucune ville disponible pour le moment.',

  // ---- (v1.177) Carte deal (DealCard) ----
  'deal.viewOffer': "Voir l'offre",
  'deal.bought': 'achetés',
  'deal.available': 'dispo',
  'deal.limitedStock': 'Stock limité',
  'deal.day': 'jour',
  'deal.days': 'jours',
  'deal.ongoing': 'En cours',
  'deal.expired': 'Expiré',
  'deal.addToCart': 'Ajouter au panier',

  // ---- (v1.177) Pied de page : liens & mentions ----
  'footer.tagline': 'Plateforme premium de réservation et mise en relation entre clients et partenaires (spa, beauté, restaurants, hôtels, voyages, immobilier, services VIP…).',
  'footer.since': 'Depuis 2013 • Fiable • Transparente • Premium',
  'footer.exploreDeals': 'Explorer les deals',
  'footer.about': 'Qui sommes-nous',
  'footer.becomePartner': 'Devenir partenaire',
  'footer.contactLink': 'Contact',
  'footer.faq': 'FAQ',
  'footer.getInTouch': 'Prendre contact',
  'footer.cgv': 'CGV',
  'footer.terms': "Conditions d'utilisation",
  'footer.privacy': 'Politique de confidentialité',
  'footer.legal': 'Mentions légales',
  'footer.intermediary': 'Maxula agit en tant qu’intermédiaire entre clients et partenaires. Les prestations sont réalisées par les partenaires. (Voir CGV pour les détails.)',

  'footer.rights': 'Tous droits réservés.',
  'footer.hours': 'Lun–Sam • 10:00 – 19:00',

  // ---- (v1.178) Page Support ----
  'support.title': 'Support & Aide',
  'support.subtitle': 'Contactez-nous, nous répondons rapidement.',
  'support.sendTitle': 'Envoyer un message au support',
  'support.name': 'Votre nom',
  'support.email': 'Email',
  'support.phone': 'Téléphone',
  'support.message': 'Votre message…',
  'support.send': 'Envoyer',
  'support.sending': 'Envoi…',
  'support.writeMessage': 'Écrivez votre message',
  'support.sent': 'Message envoyé au support !',
  'support.error': "Erreur lors de l'envoi"
};

export default fr;